// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CicdGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 28">
    <path
      fill="url(#cicd-gradient_svga)"
      d="M34.88 0c-7.24 0-13.13 6.28-13.13 14 0 5.07-3.87 9.2-8.62 9.2-4.76 0-8.63-4.13-8.63-9.2s3.87-9.2 8.62-9.2a8.2 8.2 0 0 1 6.11 2.7c.85.92 2.34.92 3.19.01.88-.93.88-2.45 0-3.4q-.91-.97-2-1.75A12.5 12.5 0 0 0 13.12 0C5.9 0 0 6.28 0 14s5.89 14 13.12 14c7.24 0 13.13-6.28 13.13-14 0-5.07 3.87-9.2 8.62-9.2 4.76 0 8.63 4.13 8.63 9.2s-3.87 9.2-8.62 9.2a8.3 8.3 0 0 1-6.1-2.7 2.2 2.2 0 0 0-3.18 0 2.5 2.5 0 0 0-.66 1.7c0 .65.23 1.25.66 1.7a12.6 12.6 0 0 0 9.28 4.1C42.1 28 48 21.72 48 14S42.11 0 34.88 0"
    />
    <defs>
      <linearGradient
        id="cicd-gradient_svga"
        x1={0}
        x2={25.61}
        y1={0}
        y2={41.74}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "CicdGradient",
);
export default CicdGradientIcon;
